module.exports = __webpack_public_path__ + "static/media/insta.e44f16c2.svg";